import * as React from 'react'
import styled from 'styled-components'
import { Spin, Typography, Table } from 'antd'

export const ButtonRow = styled.div`
  display: flex;
  justify-content: space-between;
`

export const FlexedSpin = styled(
  (
    p: React.ComponentProps<typeof Spin> & {
      children: React.ReactNode
      className?: string
    }
  ) => <Spin {...p} wrapperClassName={p.className} />
)`
  flex: 1;
  max-width: 400px;
`

export const SectionTitle = styled.p`
  color: ${props => props.theme.colors.dark};
  font-weight: bolder;
  margin-top: 24px;
  &:first-child {
    margin-top: 0;
  }
`

const Padded = styled.div`
  padding: 8px 16px 0;
`

export const TableHeader = ({
  title,
  children,
}: {
  title?: React.ReactNode
  children?: React.ReactNode
}) => (
  <Padded>
    {!!title ? <Typography.Title level={3}>{title}</Typography.Title> : null}
    {!!children ? <div>{children}</div> : null}
  </Padded>
)

export const FittedTable = styled(Table)`
  overflow: hidden;
  height: 100%;

  & > .ant-spin-nested-loading,
  & > .ant-spin-nested-loading > .ant-spin-container {
    overflow: hidden;
    height: 100%;
  }

  & > .ant-spin-nested-loading > .ant-spin-container {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    & > .ant-table {
      overflow: hidden;
      display: flex;
      flex-direction: column;
      align-self: stretch;
      flex: 1;
      & > .ant-table-container {
        flex: 1;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        & .ant-table-header {
          flex-shrink: 0;
        }
      }
    }
  }
` as React.ComponentType as typeof Table
